import styles from "./AssetDetailModal.module.css";

interface ModalContainerProps {
  isMaximized: boolean;
  setIsMaximized: (isMaximized: boolean) => void;
  onClose: () => void;
  onOverlayClick: (e: React.MouseEvent) => void;
  title: string;
  url: string | undefined;
}

export function ModalContainer({
  isMaximized,
  setIsMaximized,
  onClose,
  onOverlayClick,
  title,
  url,
}: ModalContainerProps) {
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
    <div className={styles.overlay} onClick={onOverlayClick}>
      <div
        className={`${styles.modalContainer} ${
          isMaximized
            ? styles.modalContainerMaximized
            : styles.modalContainerDefault
        }`}
      >
        <div className={styles.header}>
          <button
            onClick={() => setIsMaximized(!isMaximized)}
            className={styles.button}
          >
            {isMaximized ? "Minimize" : "Maximize"}
          </button>
          <button onClick={onClose} className={styles.button}>
            Close
          </button>
        </div>
        <div className={styles.contentContainer}>
          <iframe title={title} src={url} className={styles.iframe} />
        </div>
      </div>
    </div>
  );
}
